import { useEffect } from "react";
import { useStore } from "../utils/store";
import basicSetting from "../apis/adminApis/basicSetting.api";
const REFRESH_INTERVAL_MS = 30 * 60 * 1000;

export default function BasicSettingsLoader() {
  const basicSettings = useStore((s) => s.basicSettings);
  const setBasicSettings = useStore((s) => s.setBasicSettings);
  const fetchAndApply = () => {
    basicSetting.getGeneralBasicSetting({
      success: (res) => {
        const settings = res.data?.basicSettings;
        setBasicSettings(settings);

        if (settings) {
          const faviconLink = document.querySelector("link[rel='icon']");
          if (faviconLink) faviconLink.href = settings.favicon;

          document.documentElement.style.setProperty(
            "--color-primary",
            settings.primary_color
          );

          document.title = settings.website_title || document.title;
        }
      },
      error: (err) => console.error("Basic settings load error:", err),
    });
  };

  useEffect(() => {
    if (!basicSettings) {
      fetchAndApply();
    }

    const handle = setInterval(fetchAndApply, REFRESH_INTERVAL_MS);

    return () => clearInterval(handle);
  }, [basicSettings, setBasicSettings]);

  return null;
}
